import { useEffect } from 'react'
import { useConsignments } from '../api'
import { useFilters } from './use-filters'
import { usePaginationSelectors } from './use-pagination-store'

export const usePaginatedConsignments = () => {
  const { filters } = useFilters()
  const { data } = useConsignments()
  const { setVisibleRowsCount, currentPage, evaluationKeysMap, setEvaluationKeysMap } =
    usePaginationSelectors({ pageSize: filters.pageSize })

  useEffect(() => {
    if (data.last_evaluated_key && !evaluationKeysMap[currentPage + 1]) {
      setEvaluationKeysMap({
        ...evaluationKeysMap,
        [currentPage + 1]: data.last_evaluated_key,
      })
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [data.last_evaluated_key])

  useEffect(() => {
    setVisibleRowsCount(data.items.length)
  }, [data.items.length, setVisibleRowsCount])

  return { data }
}
